var site = site || {};
site.Accordion = (() => {
    const accordionMobile = (mediaQueries) => { 
        const buttons = document.querySelectorAll('.accordion-button');

        if (buttons) {
            buttons.forEach(button => {
                if (!mediaQueries.lg.matches) {
                    button.setAttribute('data-bs-toggle', 'collapse');
                    $('.accordion-collapse').collapse('hide');
                    $('.accordion-button').prop('disabled', false);
                } else {
                    button.removeAttribute('data-bs-toggle');
                    $('.accordion-collapse').collapse('show');
                    $('.accordion-button').prop('disabled', true);
                }
            });
        }
    }

    return {
        accordionMobile : accordionMobile
    };
})();